export default __webpack_public_path__ + "static/9-3--ff657a0d6819612419bc64a77167e068.png";